import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const SecretKey = process.env.VUE_APP_SECRET_KEY || "default_fallback_secret";

export const encryptData = (data) => {
  try {
    const stringified = typeof data === "string" ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(stringified, SecretKey).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SecretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

function getDefaultCookieOptions(overrides = {}) {
  return {
    expires: 14 / 24,
    secure:
      typeof window !== "undefined" && window.location.protocol === "https:",
    sameSite: "Strict",
    ...overrides,
  };
}

export function setSecureItem(key, value, options = {}) {
  const cookieOptions = getDefaultCookieOptions(options);
  if (!key || value === undefined) {
    console.warn("setSecureItem called with invalid key or value.");
    return;
  }

  const encryptedValue = encryptData(value);
  if (encryptedValue) {
    Cookies.set(key, encryptedValue, cookieOptions);
  }
}

export function getSecureItem(key) {
  if (!key) return null;

  const encryptedValue = Cookies.get(key);
  if (!encryptedValue) return null;

  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedValue, SecretKey).toString(
      CryptoJS.enc.Utf8
    );
    try {
      return JSON.parse(decrypted);
    } catch (parseError) {
      return decrypted;
    }
  } catch (error) {
    console.error(`Error decrypting data for key "${key}":`, error);
    return null;
  }
}

export function removeSecureItem(key) {
  if (key) Cookies.remove(key);
}
